module.exports = __webpack_public_path__ + "img/tv.37673a5a.svg";